<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="internacaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Internação
                            <span v-if="dados && dados.id_internacao" class="badge badge-secondary">
                                #{{ dados.id_internacao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-loading v-if="!dados" />

                        <template v-else>
                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input
                                        sizing="sm"
                                        label="Paciente"
                                        :edicao="false"
                                        v-model="dados.paciente.search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="abrir_paciente(dados)">
                                                    <i class="fa fa-id-badge" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>

                            <div class="form-row" v-if="dados.atendimento_rn">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        sizing="sm"
                                        label="DNV (Declaração de Nascido Vivo)"
                                        placeholder="Informar..."
                                        v-model="dados.st_num_dnv">
                                    </az-input>
                                </div>
                            </div>

                            <az-sub-title class="mt-3" title="Operadora" />

                            <div class="form-row">
                                <div class="col col-12 col-md-6">
                                    <az-input 
                                        :edicao="true" 
                                        sizing="sm"
                                        label="Operadora / Plano" 
                                        type="autocomplete" 
                                        optionsMode="aql" 
                                        :optionsParm="{ atendimento: true }"
                                        optionsName="planos.atendimento"
                                        service="planos.index" 
                                        optionsDisplay="search"
                                        :optionsSync="false"
                                        v-model="dados.plano"
                                        required 
                                        :validate="validate"/>
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Número da Matrícula"
                                        sizing="sm"
                                        v-model="dados.st_numero_carteira" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        sizing="sm"
                                        :edicao="true" 
                                        label="Vencimento da Matrícula" 
                                        type="date"
                                        v-model="dados.dt_validade_carteira" 
                                        required2="!fl_particular && value.paciente_unidade.plano && value.paciente_unidade.plano.operadora && value.paciente_unidade.plano.operadora.fl_exigir_matricula" 
                                        :validate="validate"/>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                </div>

                                <div class="col col-12 col-md-4">
                                    <az-input
                                        label="Número da Guia"
                                        sizing="sm"
                                        v-model="dados.st_numero_guia" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Senha"
                                        sizing="sm"
                                        v-model="dados.st_codigo_autorizacao" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        sizing="sm"
                                        :edicao="true" 
                                        label="Validade da Senha" 
                                        type="date"
                                        v-model="dados.dt_validade_autorizacao" 
                                        :validate="validate"/>
                                </div>
                            </div>

                            <!-- Dados da Internação -->

                            <az-sub-title class="mt-3" title="Internação">
                                <a class="card-link" v-if="!dados.dt_alta" href="#" @click.prevent="reg_alta()">
                                    <i class="fas fa-sign-out-alt fa-fw mr-2"></i>
                                    Alta
                                </a>
                            </az-sub-title>

                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Acomodação"
                                        type="select"
                                        placeholder="Tipo de Acomodação..."
                                        :optionsList="[
                                            { id: 'A', search: 'Apartamento' },
                                            { id: 'E', search: 'Enfermaria' }, 
                                        ]"
                                        optionsData="id"
                                        v-model="dados.st_acomodacao" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Tipo"
                                        type="select"
                                        placeholder="Tipo de Internação..."
                                        :optionsList="[
                                            { id: 'C', search: 'Clínica' },
                                            { id: 'R', search: 'Cirúrgica' }, 
                                            { id: 'O', search: 'Obstétrica' }, 
                                            { id: 'P', search: 'Pediátrica' }, 
                                            { id: 'Q', search: 'Psiquiátrica' }, 
                                        ]"
                                        optionsData="id"
                                        v-model="dados.st_tipo" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Caratér"
                                        type="select"
                                        placeholder="Caratér da Internação..."
                                        :optionsList="[
                                            { id: 'E', search: 'Eletivo' },
                                            { id: 'U', search: 'Urgência' }, 
                                        ]"
                                        optionsData="id"
                                        v-model="dados.ch_carater" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input 
                                        sizing="sm" 
                                        type="select" 
                                        label="Regime de Internação"
                                        placeholder="Não informado..."
                                        :optionsList="[
                                            { id: '1', search: 'Hospitalar' }, 
                                            { id: '2', search: 'Hospital-Dia' }, 
                                            { id: '3', search: 'Domiciliar' }, 
                                        ]"
                                        optionsData="id"
                                        :validate="validate" 
                                        v-model="dados.ch_regime" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        sizing="sm"
                                        label="Motivo"
                                        v-model="dados.st_motivo" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Admissão"
                                        type="date"
                                        v-model="dados.dt_admissao" />
                                </div>

                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        label="Hora"
                                        type="time"
                                        v-model="dados.st_hora_admissao" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Alta"
                                        type="date"
                                        v-model="dados.dt_alta" />
                                </div>

                                <div class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        label="Hora"
                                        type="time"
                                        :edicao="dados.dt_alta ? true : false"
                                        v-model="dados.st_hora_alta" />
                                </div>

                                <div class="col col-12" :class="( tipo_alta_selec && tipo_alta_selec.fl_info_dobito ) ? 'col-md-4' : 'col-md-2'">
                                    <az-input 
                                        sizing="sm"
                                        label="Tipo de Alta"
                                        type="select"
                                        optionsData="id_tipo_alta"
                                        service="tipo_altas.index"
                                        optionsMode="aql"
                                        :edicao="dados.dt_alta ? true : false"
                                        :validate="validate"
                                        v-model="dados.id_tipo_alta" />
                                </div>

                                <div class="col col-12 col-md-2" v-if="( tipo_alta_selec && tipo_alta_selec.fl_info_dobito ) ? true : false">
                                    <az-input
                                        sizing="sm"
                                        label="Número de Declaração de Óbito"
                                        :edicao="dados.dt_alta ? true : false"
                                        :validate="validate"
                                        v-model="dados.st_num_obito" />
                                </div>
                            </div>

                            <!-- Solicitante -->
                            <medico-solicitante v-model="dados" :block_executante="true" />

                            <!-- Classificação -->

                            <div class="row mt-2">
                                <div class="col col-12">
                                    <multiselect
                                        v-model="dados.js_classes"
                                        :options="options_classes"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTag"
                                        placeholder="Classificar Paciente..."
                                        selectLabel="Pressione [ENTER] para selecionar"
                                        deselectLabel="Pressione [ENTER] para remover"
                                        tagPlaceholder="Pressione [ENTER] para incluir"
                                        selectedLabel="Selecionado">
                                        <template slot="noOptions">
                                            Nenhuma classificação criada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <!-- Localização -->

                            <az-sub-title class="mt-3" title="Localização" />

                            <div class="form-row">
                                <div class="col col-12">
                                    <az-input 
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Internação Própria"
                                        :edicao="false"
                                        v-model="dados.fl_interno" />
                                </div>
                            </div>

                            <template v-if="!dados.fl_interno">
                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            label="Hospital"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="centro_cirurgicos.index"
                                            optionsData="id_centro_cirurgico" 
                                            optionsDisplay="st_centro_cirurgico"
                                            v-model="dados.id_centro_cirurgico" 
                                            :validate="validate" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            sizing="sm"
                                            label="Unidade de Internação"
                                            v-model="dados.st_unidade_internacao" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            sizing="sm"
                                            label="Leito"
                                            v-model="dados.st_leito_nome" />
                                    </div>
                                </div>
                            </template>

                             <div v-if="dados.campos_customizados" class="row mt-3">
                                <div class="col col-12">
                                    <az-sub-title :title="dados.campos_customizados.st_titulo" />
                                    <formulario 
                                        :gutters="true" 
                                        :validate="validate"
                                        v-model="dados.campos_customizados.js_campos" 
                                        :saved="saved" 
                                        mode="fixed"
                                        :config="true" />
                                </div>
                            </div>

                            <pre v-if="false">{{ dados }}</pre>
                        </template>
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="internacao" :id="dados.id_internacao" v-if="dados && dados.id_internacao && $store.state.user.id_usuario == 1" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>   

        
        <!-- Agendados... -->
        <div class="modal fade" id="internacaoAgendadosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Marcações</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">

                        <div class="mb-3">
                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input 
                                        type="date" 
                                        v-model="data_agenda"
                                        @input="marcacoes = null">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="carregar_agendas()">
                                                    <i class="fa-solid fa-rotate"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-9">
                                    <az-input
                                        icon="fa fa-search fa-fw"
                                        placeholder="Pesquisar..."
                                        :edicao="( marcacoes && marcacoes.length ) ? true : false"
                                        v-model="marc_search">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="lista_marcacoes.length">
                                                <span class="input-group-text" id="basic-addon2">
                                                    {{ lista_marcacoes.length }}
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                            </div>
                        </div>

                        <az-empty-state v-if="!lista_marcacoes.length" msg="Nenhuma marcação identificada." icon="fas fa-calendar-plus" />

                        <div v-else>
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(marcacao, imx) in lista_marcacoes" :key="imx">
                                    <div class="row">
                                        <div class="col col-12 col-md-4">
                                            <celula-dados-paciente :hor="{ marcacao: marcacao }" />
                                        </div>
                                        <div class="col col-12 col-md-4">
                                            <celula-dados-procedimento :hor="{ marcacao: marcacao }" :blockanexos="true" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <h5 class="mb-0">
                                                <strong>{{ marcacao.dt_inicio.substr(11,5) }}</strong>
                                            </h5>
                                            <div v-if="marcacao.local" class="small">
                                                {{ marcacao.local.st_local }}
                                            </div>
                                            <div v-if="marcacao.dt_checkin" class="badge badge-primary">
                                                Check-In: {{ marcacao.dt_checkin.substr(11,5) }}
                                            </div>
                                        </div>
                                        <div class="col col-12 col-md-2 text-right">
                                            <button type="button" class="btn btn-primary btn-sm" @click="admitir(marcacao)">
                                                Selecionar
                                            </button>
                                            <div v-if="marcacao.st_id_externo" class="small text-muted">
                                                {{ marcacao.st_id_externo }}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <br><br><br><br><br><br><br><br><br><br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>    

        <!-- Admissão -->
        <div class="modal fade" id="admissaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Admissão</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="admissao">

                        <div v-if="etapa == 1">

                            <div class="form-row d-flex justify-content-center" v-if="!fluxo">

                                <div class="col">
                                    <a href="#" @click.prevent="startFluxo(2)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                                        <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                            :class="'bg-success'">
                                            <i class="fas fa-user-check fa-4x"></i>
                                            <div class="display-4 atalho-titulo mt-2">
                                                <small>Paciente</small>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div class="col">
                                    <a href="#" @click.prevent="startFluxo(1)" class="card border-0 card-templates dashcard card-link az-anime-surgir">
                                        <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                                            :class="'bg-danger'">
                                            <i class="fas fa-user-check fa-4x"></i>
                                            <div class="display-4 atalho-titulo mt-2">
                                                <small class="text-nowrap text-truncate">Primeira Vez</small>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                            </div>

                            <!-- Seleção do Paciente -->
                            <div class="row" v-if="fluxo == 2">
                                <div class="col col-12">
                                    <az-input
                                        v-if="admissao && !admissao.paciente"
                                        placeholder="Informe o nome ou CPF do paciente..."
                                        icon="fas fa-user"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="pacientes.index"
                                        optionsDisplay="search"
                                        ref="info_paciente"
                                        v-model="novo_paciente"
                                        :optimized_ac="true"
                                        @input="selecionarPaciente()" />

                                    <div v-if="admissao.paciente">
                                        <cadastro-paciente
                                                v-model="admissao.paciente"
                                                formName="cadpac"
                                                :editar="true"
                                                :noButtons="true"
                                                ref="cadPaciente"
                                                :validate="validate" />
                                    </div>
                                </div>
                            </div>

                            <!-- Paciente Primeira Vez -->
                            <div class="row" v-if="fluxo == 1">
                                <div class="col col-12">
                                    <div v-if="admissao.paciente && !admissao.paciente.id_pessoa && !admissao.paciente.verificado">
                                        <cadastro-paciente-primeira-vez 
                                            :direto="true"
                                            ref="cadPaciente1" 
                                            v-model="admissao.paciente"
                                            @selecionado="primeiraVezSelecionado" />
                                    </div>

                                    <div v-else>
                                        <cadastro-paciente
                                            v-model="admissao.paciente"
                                            formName="cadpac"
                                            :editar="true"
                                            :noButtons="true"
                                            ref="cadPaciente"
                                            :validate="validate"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Etapa 2 -->
                        <div v-if="etapa == 2">
                            <div class="alert alert-primary">
                                <div class="lead">
                                    {{ admissao.paciente.st_nome }}
                                </div>
                                <div class="small">
                                    {{ admissao.plano.search }}
                                </div>
                            </div>

                            <template v-if="admissao.plano && admissao.plano.id_operadora != 1">

                                <az-sub-title class="mt-3" title="Operadora" />

                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Número da Guia"
                                            sizing="sm"
                                            v-model="admissao.st_numero_guia" />
                                    </div>

                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            label="Senha"
                                            sizing="sm"
                                            v-model="admissao.st_codigo_autorizacao" />
                                    </div>

                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            sizing="sm"
                                            :edicao="true" 
                                            label="Validade da Senha" 
                                            type="date"
                                            v-model="admissao.dt_validade_autorizacao" 
                                            :validate="validate"/>
                                    </div>
                                </div>

                            </template>

                            <!-- Dados da Internação -->

                            <az-sub-title class="mt-3" :title="'Internação ' + ( admissao.fl_interno ? '' : 'Externa' )" />

                            <div class="form-row" v-if="admissao.fl_interno">
                                <div class="col col-12">

                                    <az-input 
                                        sizing="sm"
                                        placeholder="Selecione o leito do paciente..."
                                        type="autocomplete" 
                                        optionsMode="aql"
                                        service="locals.index"
                                        optionsName="locals.index.leitos"
                                        :optionsSync="true"
                                        required 
                                        label="Leito"
                                        v-model="admissao.local"
                                        :validate="validate"
                                        :optionsParm="{ 
                                            ativos: true,
                                            leitos: true, 
                                            leitos_livres: true
                                        }"
                                        @input312="checar_conflito_local(admissao)" />

                                </div>

                            </div>

                            <template v-else>
                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            label="Hospital"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="aql"
                                            service="centro_cirurgicos.index"
                                            optionsData="id_centro_cirurgico" 
                                            optionsDisplay="st_centro_cirurgico"
                                            v-model="admissao.id_centro_cirurgico" 
                                            :validate="validate" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            sizing="sm"
                                            label="Unidade de Internação"
                                            v-model="admissao.st_unidade_internacao" />
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <az-input 
                                            sizing="sm"
                                            label="Leito"
                                            v-model="admissao.st_leito_nome" />
                                    </div>
                                </div>
                            </template>

                            <!-- Outras Informações -->

                            <div class="form-row">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Acomodação"
                                        type="select"
                                        placeholder="Tipo de Acomodação..."
                                        :optionsList="[
                                            { id: 'A', search: 'Apartamento' },
                                            { id: 'E', search: 'Enfermaria' }, 
                                        ]"
                                        required
                                        :validate="validate"
                                        optionsData="id"
                                        v-model="admissao.st_acomodacao" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        label="Tipo"
                                        type="select"
                                        placeholder="Tipo de Internação..."
                                        :optionsList="[
                                            { id: 'C', search: 'Clínica' },
                                            { id: 'R', search: 'Cirúrgica' }, 
                                            { id: 'O', search: 'Obstétrica' }, 
                                            { id: 'P', search: 'Pediátrica' }, 
                                            { id: 'Q', search: 'Psiquiátrica' }, 
                                        ]"
                                        required
                                        :validate="validate"
                                        optionsData="id"
                                        v-model="admissao.st_tipo" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Caratér"
                                        type="select"
                                        placeholder="Caratér da Internação..."
                                        :optionsList="[
                                            { id: 'E', search: 'Eletivo' },
                                            { id: 'U', search: 'Urgência' }, 
                                        ]"
                                        optionsData="id"
                                        required
                                        :validate="validate"
                                        v-model="admissao.ch_carater" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Admissão"
                                        type="date"
                                        required
                                        :validate="validate"
                                        v-model="admissao.dt_admissao" />
                                </div>

                                <div class="col col-12 col-md-2">
                                    <az-input
                                        sizing="sm"
                                        label="Hora"
                                        type="time"
                                        required
                                        :validate="validate"
                                        v-model="admissao.st_hora_admissao" />
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="col col-12 col-md-2">
                                    <az-input 
                                        sizing="sm" 
                                        type="select" 
                                        label="Regime de Internação"
                                        placeholder="Não informado..."
                                        :optionsList="[
                                            { id: '1', search: 'Hospitalar' }, 
                                            { id: '2', search: 'Hospital-Dia' }, 
                                            { id: '3', search: 'Domiciliar' }, 
                                        ]"
                                        optionsData="id"
                                        :validate="validate" 
                                        v-model="admissao.ch_regime" />
                                </div>
                            
                                <div class="col col-12 col-md-10">
                                    <az-input 
                                        sizing="sm"
                                        label="Motivo"
                                        v-model="admissao.st_motivo" />
                                </div>
                            </div>

                            <!-- Solicitante -->
                            <medico-solicitante v-model="admissao" :block_executante="true" />

                            <!-- Classificação -->

                            <div class="row mt-3">
                                <div class="col col-12">
                                    <multiselect
                                        v-model="admissao.js_classes"
                                        :options="options_classes"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addTagAdm"
                                        placeholder="Classificar Paciente..."
                                        selectLabel="Pressione [ENTER] para selecionar"
                                        deselectLabel="Pressione [ENTER] para remover"
                                        tagPlaceholder="Pressione [ENTER] para incluir"
                                        selectedLabel="Selecionado">
                                        <template slot="noOptions">
                                            Nenhuma classificação criada.
                                        </template>
                                    </multiselect>
                                </div>
                            </div>

                            <div v-if="admissao.campos_customizados" class="row mt-3">
                                <div class="col col-12">
                                    <az-sub-title :title="admissao.campos_customizados.st_titulo" />
                                    <formulario 
                                        :gutters="true" 
                                        :validate="validate"
                                        v-model="admissao.campos_customizados.js_campos" 
                                        :saved="saved" 
                                        mode="fixed"
                                        :config="true" />
                                </div>
                            </div>
                        </div>

                        <pre v-if="false">{{ admissao }}</pre>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-secondary" @click="voltar()" v-if="fluxo">
                            <i class="fa-solid fa-chevron-left fa-fw mr-2"></i>
                            Voltar
                        </button>
                        <az-submit v-if="( fluxo == 1 && ( admissao.paciente.verificado || admissao.paciente.id_pessoa ) ) || ( fluxo == 2 && admissao.paciente && admissao.paciente.id_pessoa )" @click="admissao_proximo()">
                            <i class="fa-solid fa-chevron-right fa-fw mr-2"></i>
                            {{ ( fluxo && etapa == 2 ) ? 'Concluir' : 'Próximo' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alta Modal -->
        <div class="modal fade" id="altaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <template v-else>

                            <div class="alert alert-primary">
                                <div class="lead">
                                    {{ dados.paciente.st_nome }}
                                </div>
                                <div class="small">
                                    {{ dados.plano.search }}
                                </div>
                                <hr>
                                <div class="small">
                                    Admissao: {{ $util.getFormatDate(dados.dt_admissao) }} {{ dados.st_hora_admissao }}
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input 
                                        label="Data da Alta"
                                        type="date"
                                        required
                                        :validate="validate"
                                        v-model="dados.dt_alta" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input 
                                        label="Hora da Alta"
                                        type="time"
                                        required
                                        :validate="validate"
                                        v-model="dados.st_hora_alta" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12">
                                    <az-input 
                                        label="Tipo de Alta"
                                        type="select"
                                        optionsData="id_tipo_alta"
                                        service="tipo_altas.index"
                                        optionsMode="aql"
                                        :validate="validate"
                                        v-model="dados.id_tipo_alta" />
                                </div>
                            </div>

                            <div v-if="tipo_alta_selec && tipo_alta_selec.fl_info_dobito">
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input 
                                            label="Número de Declaração de Óbito"
                                            :validate="validate"
                                            v-model="dados.st_num_obito" />
                                    </div>
                                </div>
                            </div>

                        </template>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit :disabled="!dados" @click="atualizar('altaModal')">Registrar</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzLoading from '../../util/AzLoading.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import Multiselect from 'vue-multiselect';
import MedicoSolicitante from '../../shared/MedicoSolicitante.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';
import CadastroPacientePrimeiraVez from '../../modulos/recepcao/CadastroPacientePrimeiraVez.vue';
import CadastroPaciente from '../../shared/CadastroPaciente.vue';
import Formulario from '../consultorio/Formulario.vue';

export default {
    data() { 
        return { 
            dados: null, 
            validate: false, 
            options_classes: [],
            marcacoes: null, 
            marc_search: "", 
            fluxo: "", 
            admissao: null, 
            etapa: 1, 
            saved: true, 
            data_agenda: null, 
            novo_paciente: "", 
        }
    }, 

    components: { 
        AzLoading,
        AzInput,
        AzSubTitle, 
        AzSubmit, 
        Multiselect, 
        MedicoSolicitante, 
        AzAuditLogButton,
        AzEmptyState, 
        CelulaDadosPaciente,
        CelulaDadosProcedimento, 
        CadastroPacientePrimeiraVez,
        CadastroPaciente,
        Formulario,
    },

    computed: { 
        lista_marcacoes: function () { 
            if ( !this.marcacoes )
                return [];

            const reg = this.$util.getregex(this.marc_search);

            return _.orderBy(
                this.marcacoes.filter(item => !this.marc_search || reg.test(JSON.stringify(item))),
                ['dt_checkin', 'dt_inicio', 'nome_paciente'],
                ['asc', 'asc', 'asc']
            );
        },

        tipo_alta_selec() { 
            if ( !this.dados || !this.dados.id_tipo_alta )
                return; 
            
            let tipos = this.$store.state.options['tipo_altas.index'];

            return _.get(_.keyBy(tipos, 'id_tipo_alta'), this.dados.id_tipo_alta);
        },
    },

    methods: { 
        selecionarPaciente() { 

            if ( !this.novo_paciente )
                return;

            let paciente = _.cloneDeep(this.novo_paciente);
            this.novo_paciente = null; 

            this.$util.loadItem(this, { 
                service: 'pacientes',
                func: 'show',
                parms: { 
                    id: paciente.id_pessoa,
                }
            }) 
            .then(dados => { 
                if ( dados ) { 
                    this.admissao.paciente = ""; 

                    this.$nextTick(() => { 
                        this.admissao.paciente = dados;
                        this.novo_paciente = ""; 
                    });
                } 
            });

        },

        reg_alta () { 
            this.dados.dt_alta = this.$util.hoje();
            this.dados.st_hora_alta = this.$util.agora().substr(0,5);
        },

        primeiraVezSelecionado() { 
            this.validate = false;
        },

        validarCampos(action) {
            this.$nextTick(() => {
                let invalids = $(".invalid");

                if (invalids.length && $(".invalid").is(":visible")) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.*",
                        life: 3000
                    });
                } else {
                    action();
                }
            });
        },
        admissao_proximo() { 
            switch (this.etapa) {
                case 1:
                    this.validate = true; 

                    this.validarCampos(() => { 
                        this.admissao.plano = _.get(this.admissao, 'paciente.paciente_unidade.plano');
                        this.validate = false; 
                        this.etapa = 2;
                    });

                    break;

                case 2:
                    this.validate = true; 

                    this.validarCampos(() => { 
                        this.validate = false;

                        this.admissao.id_paciente = this.admissao.paciente.id_pessoa;
                        this.admissao.id_plano = this.admissao.plano ? this.admissao.plano.id_plano : null;
                        this.admissao.id_local = this.admissao.local ? this.admissao.local.id_local : null;
                        this.admissao.id_medico_solicitante = this.admissao.medico_solicitante 
                            ? this.admissao.medico_solicitante.id_medico_solicitante 
                            : null;

                        this.admissao.st_numero_carteira = this.admissao.paciente.paciente_unidade.st_numero_carteira;
                        this.admissao.dt_validade_carteira = this.admissao.paciente.paciente_unidade.dt_validade_carteira;

                        if ( this.admissao.plano && this.admissao.plano.operadora.fl_sus ) { 
                            this.admissao.st_numero_carteira = null;
                            this.admissao.dt_validade_carteira = null;
                        }
                        
                        this.$util.atualizar(this, { 
                            service: 'internacaos',
                            dados: this.admissao, 
                            modal: 'admissaoModal',
                            toast: true, 
                            callback: () => { 
                                this.$emit('refresh');
                            }
                        });
                    });

                    break;
            }
        },

        voltar () { 
            if ( this.etapa > 1 ) { 
                this.etapa = this.etapa - 1;
                return;
            }

            if ( this.admissao.id_marcacao ) { 
                $('.modal').modal('hide');
                this.agendados();
                return;
            }

            this.fluxo = "";
            this.admissao.paciente = "";
        },

        focusOn (item) {

            if ( this.$refs[item] ) {
                this.$refs[item].$refs.input.focus ();
            }

        },

        startFluxo(fluxo) { 
            if ( fluxo == 1 ) { 
                if ( !this.admissao.paciente ) { 
                    this.admissao.paciente = {
                        verificado: false, 
                        st_nome: "",
                        cadastro: { 
                            fl_estrangeiro: false, 
                            st_cpf: "", 
                            ch_sexo: "", 
                            dt_nascimento: "", 
                            endereco: { 
                                cidade: null, 
                            },
                            telefones: { 
                                celular: "", 
                                telefone: "",
                            },
                        },
                        paciente_unidade: { 
                            st_numero_carteira: "",
                            dt_validade_carteira: "", 
                            st_numero_prontuario: "", 
                        },
                        campos_customizados: null, 
                    };

                    this.carregar_paciente_campos_customizados(); 
                } else { 
                    this.admissao.paciente.verificado = false;
                }
            } else { 

                this.admissao.paciente = "";

            }

            this.fluxo = fluxo;

            this.$nextTick(() => { 

                if ( fluxo == 2 ) { 
                    this.focusOn('info_paciente');
                }

            });
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.dados.js_classes )
                this.dados.js_classes = [];

            this.dados.js_classes.push(newTag);
        },

        addTagAdm (newTag) {
            this.options_classes.push(newTag);

            if ( !this.admissao.js_classes )
                this.admissao.js_classes = [];

            this.admissao.js_classes.push(newTag);
        },

        carregar_agendas() { 

            this.marcacoes = null; 

            this.$util.load(this, { 
                service: 'marcacoes',
                func: 'index',
                parms: { 
                    data: this.data_agenda, 
                    internacao: true, 
                },
                loadTo: res => { 
                    this.marcacoes = res;
                }
            });

        },

        agendados() { 

            this.marc_search = "";
            this.marcacoes = null; 

            $('#internacaoAgendadosModal').modal('show');

            this.carregar_agendas(); 

        },

        incluir() { 

            this.dados = { 
                id_internacao: null, 
                medico_solicitante: {},
            };

        },

        carregar_campos_customizados () { 

            this.$util.loadItem(this, { 
                service: "campos_customizados",
                func: "preparar",
                parms: { 
                    model_type: 'App\\azure\\internacao', 
                },
            })
            .then(res => { 
                this.admissao.campos_customizados = res;
            });

        },

        carregar_paciente_campos_customizados () { 

            if ( !this.admissao || !this.admissao.paciente ) { 
                return; 
            }

            this.$util.loadItem(this, { 
                service: "campos_customizados",
                func: "preparar",
                parms: { 
                    model_type: 'App\\azure\\pessoa', 
                },
            })
            .then(res => { 
                this.admissao.paciente.campos_customizados = res;
            });

        },

        admitir(marcacao = null, filtro = null) { 
            $('.modal').modal('hide');

            let medico_solicitante = ( marcacao && marcacao.autorizacao ) 
                ? marcacao.autorizacao.medico_solicitante 
                : ( 
                    ( marcacao && marcacao.medico_solicitante ) 
                    ? marcacao.medico_solicitante
                    : { 
                        st_nome: "", 
                        st_numero_conselho: "", 
                        id_conselho: null, 
                        especialidade: "", 
                        edicao: false,
                    }
                );

            this.etapa = 1;

            this.admissao = { 
                paciente: "", 
                plano: "",
                local: "", 
                st_acomodacao: "", 
                st_numero_guia: "", 
                st_codigo_autorizacao: "", 
                ch_carater: "E", 
                st_tipo: "R", 
                dt_admissao: this.$util.hoje(), 
                st_hora_admissao: this.$util.agora().substr(0,5), 
                st_motivo: "", 
                dt_solicitacao: ( marcacao && marcacao.autorizacao ) ? marcacao.autorizacao.dt_solicitacao : "", 
                medico_solicitante: medico_solicitante,
                fl_interno: ( filtro && filtro.interno === false ) ? false : true, 
                fl_ativo: true, 
                id_marcacao: marcacao ? marcacao.id_marcacao : null, 
                id_unidade_operacao: ( filtro && filtro.interno === false && filtro.id_unidade_operacao && !isNaN(filtro.id_unidade_operacao) ) 
                    ? filtro.id_unidade_operacao 
                    : null,
                campos_customizados: [], 
                id_medico: marcacao ? marcacao.id_medico : null,
            };

            this.carregar_campos_customizados();

            if ( !marcacao ) { 
                this.fluxo = "";
            } else {
                this.admissao.st_motivo = marcacao.procedimento.st_procedimento;

                if ( marcacao.autorizacao && marcacao.autorizacao.st_guia_prestador ) { 
                    this.admissao.st_numero_guia = marcacao.autorizacao.st_guia_prestador;
                }

                if ( marcacao.autorizacao && marcacao.autorizacao.st_acomodacao ) { 
                    this.admissao.st_acomodacao = marcacao.autorizacao.st_acomodacao;
                } else if ( marcacao.js_outros_campos && marcacao.js_outros_campos.acomodacao ) { 
                    this.admissao.st_acomodacao = marcacao.js_outros_campos.acomodacao;
                }

                if ( marcacao.autorizacao && marcacao.autorizacao.st_codigo_autorizacao ) { 
                    this.admissao.st_codigo_autorizacao = marcacao.autorizacao.st_codigo_autorizacao;
                    this.admissao.dt_validade_autorizacao = marcacao.autorizacao.dt_valid_termino;
                }

                if ( marcacao.autorizacao && marcacao.autorizacao.medico_solicitante ) { 
                    this.admissao.medico_solicitante = marcacao.autorizacao.medico_solicitante;
                    this.admissao.dt_solicitacao = marcacao.autorizacao.dt_solicitacao;
                } else if ( marcacao.js_outros_campos && marcacao.js_outros_campos.dt_solicitacao ) { 
                    this.admissao.dt_solicitacao = marcacao.js_outros_campos.dt_solicitacao;
                }

                if ( marcacao.autorizacao && marcacao.autorizacao.cid_principal ) { 
                    this.admissao.id_cid = marcacao.autorizacao.id_cid_principal;
                    this.admissao.cid = marcacao.autorizacao.cid_principal;
                } else if ( marcacao.js_outros_campos && marcacao.js_outros_campos.id_cid ) { 
                    this.admissao.id_cid = marcacao.js_outros_campos.id_cid;
                    this.admissao.cid = marcacao.js_outros_campos.cid = { 
                        id_cid: marcacao.js_outros_campos.id_cid,
                        search: marcacao.js_outros_campos.cid,
                    };
                }
                
                if ( marcacao.paciente ) { 
                    this.admissao.paciente = marcacao.paciente;
                    this.admissao.paciente.paciente_unidade.plano = marcacao.plano;
                    this.admissao.plano = marcacao.plano;

                    if ( marcacao.plano.operadora.fl_sus ) { 
                        this.admissao.paciente.paciente_unidade.st_numero_carteira = "";
                        this.admissao.paciente.paciente_unidade.dt_validade_carteira = "";
                    }

                    this.fluxo = 2;

                    
                } else if ( marcacao.cadastro_temporario ) { 

                    let paciente_unidade;

                    if ( marcacao.plano.operadora.fl_sus ) { 

                        paciente_unidade = { 
                            st_sus: marcacao.cadastro_temporario.st_numero_carteira,
                            st_numero_carteira: "",
                            dt_validade_carteira: "", 
                            st_numero_prontuario: "", 
                            plano: marcacao.plano, 
                        };

                    } else { 

                        paciente_unidade = { 
                            st_sus: marcacao.cadastro_temporario.st_numero_carteira,
                            st_numero_carteira: marcacao.cadastro_temporario.st_numero_carteira,
                            dt_validade_carteira: marcacao.cadastro_temporario.dt_validade_carteira, 
                            st_numero_prontuario: "", 
                            plano: marcacao.plano, 
                        };

                    }

                    this.admissao.paciente = {
                        verificado: false, 
                        st_nome: marcacao.cadastro_temporario.st_nome,
                        st_nome_social: marcacao.cadastro_temporario.st_nome_social, 
                        st_raca: marcacao.cadastro_temporario.st_raca, 
                        cadastro: { 
                            fl_estrangeiro: false, 
                            st_nome_mae: marcacao.cadastro_temporario.st_nome_mae, 
                            st_cpf: marcacao.cadastro_temporario.st_cpf, 
                            st_rg: marcacao.cadastro_temporario.st_rg, 
                            st_email: marcacao.cadastro_temporario.st_email, 
                            ch_sexo: marcacao.cadastro_temporario.ch_sexo, 
                            dt_nascimento: marcacao.cadastro_temporario.dt_nascimento, 
                            st_raca: marcacao.cadastro_temporario.st_raca, 
                            endereco: marcacao.cadastro_temporario.endereco
                                ? marcacao.cadastro_temporario.endereco
                                : { 
                                    cidade: null, 
                                },
                            telefones: { 
                                celular: marcacao.cadastro_temporario.st_celular, 
                                telefone: marcacao.cadastro_temporario.st_telefone, 
                            },
                        },
                        paciente_unidade: paciente_unidade,
                        campos_customizados: null,
                    };

                    this.carregar_paciente_campos_customizados();

                    this.$forceUpdate();

                    this.fluxo = 1;
                }
                
            }

            $('#admissaoModal').modal('show');
        },

        abrir_paciente(item) { 
            $('.modal').modal('hide');

            this.$root.perfil(item.paciente);
        },

        abrir(id_internacao) { 
            this.dados = null; 

            $('#internacaoModal').modal('show');

            this.$util.load(this, { 
                service: 'internacaos',
                func: 'show',
                parms: { 
                    id: id_internacao,
                    com_tags: true, 
                },
                loadTo: res => { 
                    if ( !res.medico_solicitante ) { 
                        res.medico_solicitante = { st_nome: "" };
                    }

                    if ( res.lista_tags )
                        this.options_classes = res.lista_tags;

                    this.dados = res;
                }
            })
        },

        abrir_alta(id_internacao) { 
            this.dados = null; 

            $('#altaModal').modal('show');

            this.$util.load(this, { 
                service: 'internacaos',
                func: 'show',
                parms: { 
                    id: id_internacao,
                    com_tags: true, 
                },
                loadTo: res => { 
                    if ( !res.medico_solicitante ) { 
                        res.medico_solicitante = {};
                    }

                    if ( res.lista_tags )
                        this.options_classes = res.lista_tags;

                    this.dados = res;
                    this.dados.dt_alta = this.$util.hoje();
                    this.dados.st_hora_alta = this.$util.agora().substr(0,5);
                    this.dados.id_tipo_alta = ""; 
                }
            })
        },

        atualizar(modal = 'internacaoModal') { 
            this.$util.atualizar(this, { 
                service: 'internacaos',
                dados: this.dados, 
                modal: modal,
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    },

    beforeMount() { 
        this.data_agenda = this.$util.hoje();
    }
}
</script>

<style scoped>
.fixo-topo { 
  position: sticky;
  top: 100px;
  z-index: 1;
}

.modal-dialog-alto {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.atalho {
    opacity: 0.95;
}

.atalho:hover {
	opacity: 1;
}

.atalho:hover i {
    -webkit-transition: opacity 0.2s ease-in;
    -moz-transition: opacity 0.2s ease-in;
    -o-transition: opacity 0.2s ease-in;
    transition: opacity 0.2s ease-in;
    opacity: 0;
}

.atalho:hover div {
	-webkit-transform: translate3d(0,-30px,0);
	transform: translate3d(0,-30px,0);
}

.atalho:hover div {
	-webkit-transition-delay: 0.05s;
	transition-delay: 0.05s;
	-webkit-transition-duration: 0.35s;
	transition-duration: 0.35s;
}

.atalho i,
.atalho div {
	-webkit-transition: -webkit-transform 0.35s;
	transition: transform 0.35s;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

.az-anime-slide {
    left: -10px;
    animation: az-slide 0.5s forwards;
    animation-delay: 2s;
}

@keyframes az-slide {
    100% { left: 0; }
}

.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>